const AuditApiUrl = {
    GET: `${process.env.REACT_APP_CNG_ADMIN_ORIGIN_URL}/cng-admin/audit-header/get`
    
  };
  
  export default AuditApiUrl